var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "PaymentDiscover",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-discover","viewBox":"0 0 500 312"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <rect width="500" height="312" fill="#F8F8F8" className="dibsvg-color-holder"/>
  <path fill="#F6821F" d="M500 311.122V178.565c-33.4 20.876-158.65 92.895-363.226 132.557H500z" className="dibsvg-color-triangle"/>
  <path fill="#F6821F" d="M228.624 144.122c0 16.7 12.525 29.225 28.181 29.225 15.657 0 28.182-12.525 28.182-29.225a28.064 28.064 0 0 0-28.182-28.182 28.064 28.064 0 0 0-28.181 28.182z" className="dibsvg-color-circle"/>
  <g fill="#202020" className="dibsvg-color-letters" transform="translate(81.162 115.23)">
    <path d="M332.206 2.797c-2.087 0-4.175 2.088-4.175 4.175 0 2.088 2.088 4.175 4.175 4.175 2.088 0 4.175-2.087 4.175-4.175 0-2.087-2.087-4.175-4.175-4.175zm0 7.307c-2.087 0-3.131-1.044-3.131-3.132 0-2.087 1.044-3.131 3.131-3.131 2.088 0 3.131 2.088 3.131 3.131 0 2.088-1.043 3.132-3.13 3.132zm-5.219 8.35c0-10.438-7.306-16.7-18.787-16.7h-15.657v55.318h10.438V35.154h1.044l14.612 21.918h12.525l-16.7-22.962c8.35-2.088 12.525-7.306 12.525-15.656zm-20.875 9.393h-3.131v-16.7h3.131c6.263 0 9.394 3.132 9.394 8.35 1.044 5.22-3.131 8.35-9.394 8.35z"/>
    <path d="M102.58 29.935c0 16.7 12.525 29.225 28.182 29.225 4.175 0 8.35-1.044 12.525-3.131V43.504c-4.175 4.175-7.307 6.262-12.525 6.262-10.438 0-17.744-8.35-17.744-18.787 0-10.438 7.306-18.788 17.744-18.788 5.218 0 8.35 2.088 12.525 6.263V5.929c-4.175-2.088-8.35-3.132-12.525-3.132C115.105.71 102.58 13.235 102.58 29.935m-18.787-6.263c-6.263-2.087-8.35-4.175-8.35-7.306 0-3.131 3.13-6.262 7.306-6.262 3.131 0 5.219 1.043 8.35 4.175l5.219-7.307C92.143 2.797 86.924.71 80.66.71c-9.393 0-16.7 6.262-16.7 15.656 0 7.306 3.132 11.481 12.525 14.613 4.175 1.043 6.263 2.087 7.307 3.13 2.087 1.045 3.13 3.132 3.13 5.22 0 4.175-3.13 7.306-8.35 7.306-5.218 0-8.35-2.088-11.48-7.306L60.83 45.59c5.219 7.306 10.438 10.438 18.788 10.438 10.437 0 17.743-7.307 17.743-17.744 2.088-6.263-2.087-10.438-13.568-14.613"/>
    <path d="M14.905 1.754H.292v55.318h14.613c8.35 0 13.569-2.087 18.787-6.262 6.263-5.219 9.394-13.569 9.394-20.875 1.044-16.7-11.481-28.181-28.181-28.181zm12.525 41.75c-3.131 3.13-7.306 4.175-14.613 4.175H10.73V11.147h3.131c6.263 0 10.438 1.044 14.613 4.175 3.13 3.132 5.218 8.35 5.218 13.57-1.043 6.262-3.13 11.48-6.262 14.612z"/>
    <polyline points="257.056 57.072 286.281 57.072 286.281 47.679 267.493 47.679 267.493 33.066 285.237 33.066 285.237 23.672 267.493 23.672 267.493 11.147 286.281 11.147 286.281 1.754 257.056 1.754 257.056 57.072"/>
    <polyline points="226.787 39.329 212.174 1.754 201.737 1.754 223.656 58.116 228.874 58.116 251.837 1.754 240.356 1.754 226.787 39.329"/>
    <polygon points="48.305 1.754 58.742 1.754 58.742 57.072 48.305 57.072"/>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/payment-discover.svg